import { ESendByCallPetitions, sendByCall } from '@r1-frontend/api-domru/api-request/v1/user/by-call';
import { doRequest } from '@r1-frontend/do-request';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import selectProviderId from '~/src/store/selectors/selectProviderId';

export const useRequest = () => {
    const providerId = useSelector(selectProviderId);

    const [isError, setIsError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const makeRequest = useCallback(async({ phone, name, onSuccess }) => {
        setIsLoading(true);
        const dataParams = {
            fio: name,
            phone: phone,
            petition: ESendByCallPetitions.RequestNew,
        };

        try {
            const result = await doRequest.apiRequest(
                sendByCall(providerId, dataParams),
            );
            if (result.isSuccess) {
                if ('function' === typeof onSuccess) {
                    onSuccess();
                }

                setIsError(!result.isSuccess);
                setSuccess(true);
                setMessage(result.message);
            } else {
                setIsError(true);
            }
        } finally {
            setIsLoading(false);
        }
    }, [providerId]);

    const reset = () => {
        setIsError(false);
        setMessage(null);
        setIsLoading(false);
        setSuccess(false);
    };

    return ([{ isError, message, isLoading, success }, makeRequest, reset]);
};
